var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWstFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v45H0V0Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v22.5H0V0Z",
    fill: "#002B7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.875 21.497-1.94-1.313-1.866 1.322.61-2.334-1.782-1.425 2.297-.14.76-2.213.824 2.25 2.25.065-1.78 1.529.627 2.259Zm-.337-15.525L14.98 4.969l-1.5.975.413-1.875-1.369-1.19 1.819-.15.675-1.745.694 1.753 1.79.16-1.378 1.256.413 1.819ZM9.694 11.55l-1.5-1.031-1.566 1.031.488-1.819-1.416-1.2 1.8-.094.656-1.78.638 1.771 1.837.103-1.406 1.172.469 1.847Zm13.744-1.238-1.444-.937-1.406.938L21 8.597 19.688 7.49l1.715-.141.59-1.612.657 1.63 1.66.095-1.285 1.153.413 1.697Zm-4.04 4.07-.967-.6-.965.618.253-1.153-.863-.778 1.125-.094.432-1.088.46 1.088 1.115.094-.853.778.262 1.134Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWstFlag);
export default __webpack_public_path__ + "static/media/wst-flag.92fedf12e0666ba2e7183e160b73c010.svg";
export { ForwardRef as ReactComponent };